import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { SocketService } from 'src/app/services/app/socket-service/socket-service.service';
import { error } from 'console';
import { sweetAlert } from 'src/app/utils/swal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
// import { SocketService } from 'src/app/services/socket-service/socket-service.service';
@UntilDestroy()

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  showPassword = false;
  signInForm!: FormGroup;
  submitted = false;
  roles = "company";

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.signInForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
    });
  }

  onSignIn() {
    this.submitted = true;

    if (this.signInForm.invalid) {
      return;
    }

    const payload = {
      ...this.signInForm.value,
      role: 'broker'
    }

    this.authService
      .signin(payload)
      // .pipe(takeUntil(componentDestroyed(this)))
      .pipe(untilDestroyed(this)).subscribe(data => {
        if (data && data.user && data.tokens) {
          const user = {
            ...data.user,
            tokens: data.tokens
          }
          this.sharedDataService.saveUser(user);
          const tokens = data.tokens;
          if (tokens.access && tokens.access.token) {
            this.authService.setToken('access_token', tokens.access.token);
            this.authService.setTokenExpiry('access_token_expiry', tokens.access.expires);
          }
          if (tokens.refresh && tokens.refresh.token) {
            this.authService.setToken('refresh_token', tokens.refresh.token);
          }
          this.socket.connectSocket();
          this.router.navigateByUrl('/');
        } else {
          // sweetAlert("Error", data.message, "warning", "OK");
        }
      },(err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  get form() {
    return this.signInForm.controls;
  }

  ngOnDestroy(): void { }

}
